import axios from 'axios'
import { getRequestHeaders } from '../api'
import { baseUrl } from '../assets/Animations'

const normalizeText = (value) => String(value || '').trim()

const normalizeSources = (sources) => (Array.isArray(sources) ? sources : [])
  .map((source) => ({
    title: normalizeText(source?.title || source?.name),
    url: normalizeText(source?.url || source?.link),
    updatedAt: normalizeText(source?.updatedAt || source?.lastUpdated),
    excerpt: normalizeText(source?.excerpt || source?.text),
  }))
  .filter((source) => source.title || source.url)

export const askAtharoAi = async ({ question, messages = [], conversationId = '' }) => {
  const response = await axios.post(
    `${baseUrl}/atharo-ai/chat`,
    {
      question: normalizeText(question),
      messages,
      ...(conversationId ? { conversationId } : {}),
    },
    getRequestHeaders()
  )

  const payload = response?.data || {}
  const answer = normalizeText(payload.answer || payload.message || payload.output_text)
  if (!answer) throw new Error('Atharo AI returned an empty answer.')

  return {
    answer,
    conversationId: normalizeText(payload.conversationId || payload.sessionId),
    sources: normalizeSources(payload.sources || payload.citations),
  }
}

